// extracted by css-extract-rspack-plugin
export default {"box":"y0gEaSTnYyYJpHEj","heading":"gzANPKzD4MgWn8Lp","description":"X2ddd9WD0s4MpYAs"};